import { DEFAULT_CATALOG_IMAGE_URL } from '@/lib/catalogImages'
import type { OptionalFeeTemplate } from '@/types/billing'

export function defaultFeeImageUrl(_type: string): string {
  return DEFAULT_CATALOG_IMAGE_URL
}

export function optionalFeeImageUrl(
  fee: Pick<OptionalFeeTemplate, 'image_url'>
): string | null {
  return fee.image_url || null
}
